import { CloserFile } from "./types";
import { SelectSalesRepWrap } from "./styles";
import OpenInHomePageButton from "../searches/OpenInHomePageButton";

const SettlementTable = ({ rows, noSelection }: { rows: CloserFile[]; noSelection?: boolean }) => {
  return (
    <div className="data-table">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th></th>
              <th className="amountCell">Deal Amount</th>
              <th className="amountCell">Premium</th>
              <th className="stateCell">State</th>
              <th>Client</th>
              <th>Sales Rep</th>
              <th className="linkCell">Link</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={row.number}>
                <td>{index + 1}.</td>
                <td className="amountCell">
                  {row.dealAmount?.toLocaleString("en-US", { style: "currency", currency: "USD" })}
                </td>
                <td className="amountCell">
                  {row.premium?.toLocaleString("en-US", { style: "currency", currency: "USD" })}
                </td>
                <td className="stateCell">{row.state}</td>
                <td>{row.calculatedClient}</td>
                <td>{row.marketingRep}</td>
                <td className="linkCell">{row.number && <OpenInHomePageButton orderNumber={row.number} isLink />}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {noSelection && (
          <SelectSalesRepWrap>
            <div>Please select a closer</div>
          </SelectSalesRepWrap>
        )}
      </div>
    </div>
  );
};

export default SettlementTable;
